
import { UseFormRegister, FieldErrors } from 'react-hook-form';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import type { FormData } from '../types';

interface NameFieldProps {
  register: UseFormRegister<FormData>;
  errors: FieldErrors<FormData>;
}

export const NameField = ({ register, errors }: NameFieldProps) => {
  return (
    <div className="grid gap-2">
      <Label htmlFor="name">Provider Name *</Label>
      <Input
        id="name"
        {...register('name', { required: 'Name is required' })}
      />
      {errors.name && (
        <p className="text-sm text-destructive">{errors.name.message}</p>
      )}
    </div>
  );
};
